import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, take } from 'rxjs';
import { VariantService } from '@core/services/variant/variant.service';
import { BlindStateService } from '@core/services/blind-state/blind-state.service';
import { ShareService } from '@core/services/share-data/share-data.service';
import { filter, map } from 'rxjs/operators';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { STORAGE_NAMES } from '@root/app.config';
import { PartAvailabilityService } from '@core/services/part-availability/part-availability.service';

@Injectable({
	providedIn: 'root',
})
export class BlindConfigurationGuard implements CanActivate {
	constructor(
		private variantService: VariantService,
		private blindStateService: BlindStateService,
		private shareDataService: ShareService,
		private sessionStorageService: SessionStorageService,
		private router: Router,
		private partAvailabilityService: PartAvailabilityService,
	) {}
	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this.variantService.isShop()) {
			return true;
		}

		const hasSavedSession = !!route.queryParams[''];
		const blinds = this.sessionStorageService.getBlindData(STORAGE_NAMES.zip_blind_data);

		if (hasSavedSession && !blinds) {
			return this.shareDataService.isBlindsConfigReady.pipe(
				filter(Boolean),
				take(1),
				map(() => this.canActivateBlinds(route)),
			);
		}

		return this.canActivateBlinds(route);
	}

	private canActivateBlinds(route: ActivatedRouteSnapshot): boolean | UrlTree {
		if (!this.blindStateService.allBlindsConfigured() || !this.partAvailabilityService.allBlindsValid()) {
			return this.getRedirectToHomePage(route);
		}
		return true;
	}

	private getRedirectToHomePage(route: ActivatedRouteSnapshot): UrlTree {
		return this.router.createUrlTree(['/home'], { queryParams: route.queryParams });
	}
}
